import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';
import { base64ToBlob, blobToBase64 } from 'base64-blob';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        if(typeof window !== 'undefined'){
            const heic2any = require("heic2any");
            const {
                executionObject={}
            } = functionObj;
            const {
                variableName='', 
                variableUnavailable=false, 
            } = executionObject;
    
            if(!variableName || variableUnavailable){
                return {
                    updatedVariableObject : variableObject,
                    hasError : true,
                    errorPayload : 'Variable name is missing.',
                    hasReturnStatement : false,
                    returnStatement : undefined
                }
            }
    
            let parsedParameters = await bulkExpressionParser({
                executionObject,
                variableObject,
                parameterObject,
                functionMap,
                variableIdMap,
                useAllFields : true
            });
    
            let variableCopy = parsedParameters['variableObject'];
            if(parsedParameters.error){
                variableCopy[variableName] = {
                    error : {
                        message : 'Failed to resolve function parameters.'
                    }
                }
                return {
                    updatedVariableObject : variableCopy,
                    hasError : true,
                    errorPayload : 'Failed to resolve function parameters.',
                    hasReturnStatement : false,
                    returnStatement : undefined
                }
            }
    
            let resolvedParams = parsedParameters['accumulator'];
            if(
                !resolvedParams.base64 ||
                typeof resolvedParams.base64 !== 'string'
            ){
                variableCopy[variableName] = {
                    error : {
                        message : 'File base64 must be a valid string.'
                    }
                }
                return {
                    updatedVariableObject : variableCopy,
                    hasError : true,
                    errorPayload : 'File base64 must be a valid string.',
                    hasReturnStatement : false,
                    returnStatement : undefined
                }
            }
    
            if(
                !resolvedParams.toType ||
                ![
                    'image/png', 'image/jpg', 'image/gif'
                ].includes(resolvedParams.toType)
            ){
                variableCopy[variableName] = {
                    error : {
                        message : 'A valid toType is required.'
                    }
                }
                return {
                    updatedVariableObject : variableCopy,
                    hasError : true,
                    errorPayload : 'A valid toType is required.',
                    hasReturnStatement : false,
                    returnStatement : undefined
                }
            }
    
            let blobFile;
            if(resolvedParams.blobUrl){
                let blobResponse = await fetch(resolvedParams.blobUrl);
                blobFile = await blobResponse.blob();
            }else{
                blobFile = await base64ToBlob(resolvedParams.base64);
            }
            let conversionOptions = {
                blob : blobFile,
                toType : resolvedParams.toType,
                quality : resolvedParams.quality
            };
            if(resolvedParams.multiple === true){
                conversionOptions['multiple'] = resolvedParams.multiple;
            }
            if(
                resolvedParams.gifInterval && 
                (resolvedParams.toType === 'image/gif')
            ){
                conversionOptions['gifInterval'] = resolvedParams.gifInterval;
            }
            let convertedFile = await heic2any(conversionOptions);
            let finalFile;
            if(resolvedParams.multiple === true){
                finalFile = [];
                for (let i = 0; i < convertedFile.length; i++){
                    let fileBlob = convertedFile[i];
                    let fileBase64 = await blobToBase64(fileBlob);
                    finalFile.push(fileBase64);
                }
            }else{
                finalFile = await blobToBase64(convertedFile);
            }
    
            variableCopy[variableName] = finalFile;
    
            return {
                hasError : false,
                errorPayload : undefined,
                hasReturnStatement : false,
                returnStatement : undefined,
                updatedVariableObject : variableCopy
            }
        }else{
            return {
                hasError : false,
                errorPayload : undefined,
                hasReturnStatement : false,
                returnStatement : undefined,
                updatedVariableObject : variableObject
            }
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/heicBrowserConverterParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}